import { Collapse, List, ListItemIcon, ListItemText } from "@material-ui/core";
import MuiListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import { Drawer } from "boros";
import ClassNames from "classnames";
import { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { logsPath, sessionPath, teamPath } from "../../config/GetPagePath";
import { Role } from "../../config/Roles";
import AuthApi from "../../context/AuthApi";
import { getLocalValue } from "../../utils/auth";
import { isNonProduction } from "../../utils/env";
import { getAllowedRoutes } from "../../utils/getAllowedRoutes";
import FlashCoachLogo from "../_Icons/FlashCoachLogo";
import styles from "./index.module.scss";

import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import PersonOutlinedIcon from "@material-ui/icons/PersonOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import GlobeIcon from "../../images/icons/globe.svg";
// import DashboardIcon from "../../images/icons/dashboard.svg";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";

import Select from "../Select";

import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { LanguageConfig, LanguageLabelConfig } from "../../config/Config";

const ListItem = withStyles({
  root: {
    position: "relative",
    "&$selected": {
      backgroundColor: "transparent",
    },
    "&$selected svg:first-child": {
      color: "#E35646",
    },
    "&$selected span": {
      color: "#212121",
    },
    "&::before": {
      content: '""',
      width: "4px",
      height: "100%",
      backgroundColor: "#FAFAFA",
      position: "absolute",
      top: 0,
      left: 0,
      borderRadius: "0 8px 8px 0",
    },
    "&$selected::before": {
      backgroundColor: "#E35646",
    },
  },
  selected: {},
})(MuiListItem);

const NestedListItem = withStyles({
  root: {
    "&$selected": {
      backgroundColor: "transparent",
    },
    "&$selected span": {
      color: "#212121",
    },
  },
  selected: {},
})(MuiListItem);

export function DashboardDrawer(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const Auth = useContext(AuthApi);

  const [userDetails, setUserDetails] = useState({
    fullName: "",
    role: "",
    roleId: null,
  });

  const drawerList = [
    {
      text: t("leftNavigation.dashboard"),
      path: "https://app.powerbi.com/groups/827b0ecc-37be-4917-86fa-d3fc7aa80e17/reports/ce72f9a6-eae1-447a-b351-1f416c42f660/ReportSection?experience=power-bi",
      icon: <DashboardOutlinedIcon />,
      isExternalUrl: true,
      permission: [
        Role.COACH,
        Role.CAMPAIGN_MANAGER,
        Role.COE_ADMIN,
        Role.EXECUTIVE,
        Role.COORDINATOR,
        Role.CEO,
      ],
    },
    {
      text: t("leftNavigation.scoresheet"),
      path: "/dashboard",
      icon: <AssessmentOutlinedIcon />,
      permission: [
        Role.COACH,
        Role.COACHEE,
        Role.CAMPAIGN_MANAGER,
        Role.COE_ADMIN,
        Role.EXECUTIVE,
        Role.COORDINATOR,
        Role.CEO,
      ],
    },
    {
      text: t("leftNavigation.sessions"),
      path: sessionPath(),
      icon: <CalendarTodayOutlinedIcon />,
      permission: [
        Role.COACHEE,
        Role.COACH,
        Role.CAMPAIGN_MANAGER,
        Role.SUPPORT_ADMIN,
        Role.COORDINATOR,
      ],
    },
    {
      text: t("leftNavigation.warningLetters"),
      path: "/warningLetters",
      icon: <ErrorOutlineIcon />,
      permission: [Role.HR],
    },
    {
      text: t("leftNavigation.teams"),
      path: teamPath(),
      icon: <GroupOutlinedIcon />,
      permission: [
        Role.COACH,
        Role.CAMPAIGN_MANAGER,
        Role.SUPPORT_ADMIN,
        Role.COORDINATOR,
      ],
    },
    {
      text: t("leftNavigation.profile"),
      path: `/profile/`,
      icon: <PersonOutlinedIcon />,
      permission: [Role.COACHEE],
    },
    {
      text: t("leftNavigation.logs"),
      path: logsPath(),
      icon: <AssignmentOutlinedIcon />,
      permission: [
        Role.COACHEE,
        Role.COACH,
        Role.CAMPAIGN_MANAGER,
        Role.SUPPORT_ADMIN,
        Role.COORDINATOR,
      ],
    },
    {
      text: t("leftNavigation.settings"),
      path: "/settings",
      icon: <SettingsOutlinedIcon />,
      children: [
        {
          text: t("leftNavigation.userManagement"),
          path: "/settings/userManagement",
          permission: [
            Role.SUPER_ADMIN,
            Role.IT_MANAGER,
            Role.CAMPAIGN_MANAGER,
            Role.SUPPORT_ADMIN,
            Role.COE_ADMIN,
            Role.COORDINATOR,
          ],
        },
        {
          text: t("leftNavigation.subjectManagement"),
          path: "/settings/subjectManagement",
          permission: [
            Role.SUPER_ADMIN,
            Role.IT_MANAGER,
            Role.CAMPAIGN_MANAGER,
            Role.SUPPORT_ADMIN,
            Role.COE_ADMIN
          ],
        },
        {
          text: t("leftNavigation.campaignManagement"),
          path: "/settings/campaignManagement",
          permission: [
            Role.SUPER_ADMIN,
            Role.SUPPORT_ADMIN,
          ],
        },
        {
          text: t("leftNavigation.regionManagement"),
          path: "/settings/regionManagement",
          permission: [
            Role.SUPER_ADMIN,
            Role.SUPPORT_ADMIN,
          ],
        },
        {
          text: t("leftNavigation.overallCoachingReport"),
          path: "/settings/overallCoachingReport",
          permission: [
            Role.SUPPORT_ADMIN,
          ]
        },
        {
          text: t("leftNavigation.changePassword"),
          path: "/settings/changePassword",
        },
        {
          text: t("leftNavigation.changeSecurityQuestion"),
          path: "/settings/changeSecurityQuestion/",
          permission: [
            Role.COACHEE,
            Role.COACH,
            Role.CAMPAIGN_MANAGER,
            Role.SUPPORT_ADMIN,
            Role.COORDINATOR,
            Role.SUPER_ADMIN,
            Role.IT_MANAGER,
            Role.COE_ADMIN,
            Role.EXECUTIVE,
            Role.CEO,
          ],
        },
      ],
    },
    {
      text: t("leftNavigation.helpAndSupport"),
      path: "/help-support",
      icon: <HelpOutlineOutlinedIcon />,
    },
    // Non-prod only; the matching routes are flagged nonProdOnly in src/routes.js.
    ...(isNonProduction()
      ? [
          {
            text: "PII Detection Logs",
            path: "/pii-admin/detection-logs",
            icon: <AssignmentOutlinedIcon />,
          },
          {
            text: "Nudge Log Sessions",
            path: "/nudge-logs/sessions",
            icon: <AssignmentOutlinedIcon />,
          },
          {
            text: "Prompt Templates",
            path: "/prompt-templates",
          },
          {
            text: "PII Occurrences",
            path: "/pii-admin/occurrences",
            icon: <AssignmentOutlinedIcon />,
          },
        ]
      : []),
  ];
  const currentPage = window.location.pathname.split("/")[1];
  const isSettings = currentPage === "settings" ? true : false;
  const [open, setOpen] = useState(isSettings);
  const allowedRoutes = getAllowedRoutes(drawerList);
  const [languageList, setLanguageList] = useState([
    {
      label: "English",
      value: "en",
      id: 1,
    },
  ]);

  useEffect(() => {
    // possible TODO: currently only getting name+role details from localstorage. For stability, query from backend if possible.
    setUserDetails({
      ...userDetails,
      fullName: getLocalValue("u_fullname"),
      role: getLocalValue("u_levelid"), // TODO: levelid is just a number and doesn't really mean anything. ask backend team to pass over Job Role string.
      roleId: parseInt(getLocalValue("u_role")),
    });

    const userCountry = getLocalValue("region");
    if (
      userCountry === "Thailand" ||
      userCountry === "China" ||
      userCountry === "Hong Kong" ||
      userCountry === "Korea"
    ) {
      const newList = {
        label: LanguageLabelConfig[userCountry],
        value: LanguageConfig[userCountry],
        id: languageList.length + 1,
      };
      setLanguageList([...languageList, newList]);
    }
    // eslint-disable-next-line
  }, []);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleSelected = (menuItem, nested) => {
    if (nested) {
      return window.location.pathname.includes(menuItem);
    }
    const menuParent = menuItem.split("/")[1];
    const currentPage = window.location.pathname.split("/")[1];
    return menuParent === currentPage;
  };

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={props.open}
      className={styles.drawer}
    >
      <div className={styles.drawerHeader}>
        <div className={styles.drawerLogo}>
          <FlashCoachLogo />
        </div>
      </div>
      <List>
        {allowedRoutes.map((listItem, index) => (
          <Fragment key={listItem.text}>
            <ListItem
              className={ClassNames(styles.listItem, "grey-500")}
              selected={handleSelected(listItem.path)}
              button
              disableRipple
              onClick={
                listItem.children
                  ? handleClick
                  : () => {
                    if (
                      listItem.isExternalUrl &&
                      listItem.isExternalUrl === true
                    ) {
                      return window.open(listItem.path, "_blank");
                    } else {
                      history.push(listItem.path);
                    }
                  }
              }
            >
              <ListItemIcon>{listItem.icon}</ListItemIcon>
              <ListItemText>
                <div className="text-medium">{listItem.text}</div>
              </ListItemText>
              {listItem.children && (
                <Fragment>{open ? <ExpandLess /> : <ExpandMore />}</Fragment>
              )}
            </ListItem>
            {listItem.children && (
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {getAllowedRoutes(listItem.children).map(nestedItem => (
                    <NestedListItem
                      button
                      key={nestedItem.text}
                      className={ClassNames(styles.nestedListItem, "grey-500")}
                      selected={handleSelected(nestedItem.path, true)}
                      onClick={() => {
                        history.push(nestedItem.path);
                      }}
                    >
                      <ListItemText>
                        <div className="text-medium">{nestedItem.text}</div>
                      </ListItemText>
                    </NestedListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </Fragment>
        ))}
      </List>
      {languageList.length > 1 && (
        <div className={styles.languageMenuWrapper}>
          <img src={GlobeIcon} alt="Language selection" />
          <Select
            className={styles.dropdownSelect}
            variant="standard"
            list={languageList}
            value={i18next.language}
            onChange={e => {
              i18next.changeLanguage(e.target.value);
            }}
          />
        </div>
      )}
    </Drawer>
  );
}
